import React, { useEffect } from "react";
import { Modal } from 'react-bootstrap-v5';
import Swal from 'sweetalert2';
import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from "clsx";
import ICalendarioFeriado from "../../interfaces/ICalendarioFeriado";

const CalendarioNovoModal = ({ toggleModal, salvar, remover, feriado, show }: { toggleModal: () => void, salvar: (feriado: ICalendarioFeriado) => void, remover: (feriado: ICalendarioFeriado) => void, feriado: ICalendarioFeriado | null, show: boolean }) => {
    useEffect(() => {
        async function popularCampos() {
            if (feriado) {
                await formik.setValues(feriado);
                await formik.setFieldTouched('descricao', feriado.descricao !== '')
            }
        }

        popularCampos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const feriadoSchema = Yup.object().shape({
        descricao: Yup.string()
            .min(3, 'Minimo 3 caracteres')
            .max(50, 'Maximo 50 caracteres')
            .required('Descrição é obrigatório'),
        dataFeriado: Yup.string()
            .min(10)
            .max(10)
            .required()
    });

    const formik = useFormik({
        initialValues: { descricao: '', dataFeriado: '' } as ICalendarioFeriado,
        validationSchema: feriadoSchema,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            try {
                salvar({ ...values, id: feriado?.id } as ICalendarioFeriado);
                setSubmitting(false);
            } catch (error) {
                setSubmitting(false)
                Swal.fire({
                    text: 'Não foi possivel salvar o calendário', //TODO: Tratar mensagem de erro
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }
        },
    })

    async function removerFeriado() {
        try {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-modal-excluir ms-5',
                    cancelButton: 'btn btn-modal-cancelar'
                },
                buttonsStyling: false
            });

            let result = await swalWithBootstrapButtons.fire({
                title: 'Excluir Feriado',
                text: `Você realmente deseja excluir esse Feriado?`,
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: `Excluir`,
                reverseButtons: true
            });

            if (result.isConfirmed && feriado) {
                remover(feriado)
            }
        } catch (error) {
            Swal.fire({
                text: 'Ocorreu um erro ao tentar excluir o feriado', //error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        }
    }

    return <>
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal">{feriado?.id ? 'Editar Feriado' : 'Adicionar Feriado'}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <form className="row g-3">
                        <div className="col-md-12">
                            <label htmlFor="form-descricaoData" className="form-label required">Data Selecionada</label>
                            <input disabled placeholder="Digite Algo" {...formik.getFieldProps('dataFeriado')} type="text" className="form-control" id="form-descricaoData" />
                        </div>

                    </form>
                </div>
                <div className="modal-body">
                    <form className="row g-3">
                        <div className="col-md-12">
                            <label htmlFor="form-calendario-descricao" className="form-label required">Descrição</label>
                            <input {...formik.getFieldProps('descricao')} placeholder="Digite Algo" type="text"
                                className={clsx(
                                    'form-control',
                                    {
                                        'is-invalid': formik.touched.descricao && formik.errors.descricao,
                                    },
                                    {
                                        'is-valid': formik.touched.descricao && !formik.errors.descricao,
                                    }
                                )}
                                id="form-calendario-descricao" />
                        </div>

                    </form>
                </div>
                <div className="modal-footer" style={{ margin: '0 auto' }}>
                    <button onClick={toggleModal} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>

                    {
                        feriado?.id && (
                            <button onClick={removerFeriado} type="button" className="btn btn-modal-excluir me-5 ms-5"> REMOVER </button>
                        )
                    }


                    <button disabled={formik.isSubmitting || !formik.isValid} onClick={() => {
                        formik.submitForm();
                    }} type="button" className="btn btn-primario ms-5"> SALVAR </button>
                </div>
            </div>
        </Modal>
    </>
}

export default CalendarioNovoModal;